import { VideoColorFinderFlight } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateVideoColorFinderFlightArgs,
    getDefaultVideoColorFinderFlightCreateArgs,
    UpdateVideoColorFinderFlightArgs,
} from "@nova/serializer/src/client/validators/flights/videoColorFinder"
import { selectVideoColorFinderFlights } from "features/entity-caching/flights/selectors"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { v4 as randomUUID } from "uuid"
import { setFlightId } from "features/map/control/slice"
import { deleteUploadSet } from "plugins/ColorFinder/VideoColorFinder/ColorFinderSlice"
import { SampleDataFlightKey } from "@nova/constants"
import { selectSingleLayer, setActiveLayerId } from "panels/content/side-panel/slice.new"

const {
    create: createVideoColorFinderFlight,
    update: updateVideoColorFinderFlight,
    delete: deleteVideoColorFinderFlight,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    VideoColorFinderFlight, // entity type
    CreateVideoColorFinderFlightArgs, // create args to send to server
    ["createdBy", "isCreatedFromVideo"], // create args required by action
    UpdateVideoColorFinderFlightArgs, // update args
    { name?: string; sampleDataFlightKey?: SampleDataFlightKey },
    { sampleDataFlightKey?: SampleDataFlightKey }
>("VideoColorFinderFlight")

export const addVideoColorFinderFlightsToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data, context } }, socket) => {
            const state = store.getState()
            const flights = selectVideoColorFinderFlights(state)
            const name = context?.name || `Video Colorfinder ${Object.values(flights).length + 1}`
            const args = {
                name,
                id: randomUUID(),
                demoId: !!context?.sampleDataFlightKey ? "doesnt-matter" : undefined,
            }
            const optimisticData = {
                ...args,
                ...getDefaultVideoColorFinderFlightCreateArgs(state.project.data),
                ...data,
            }
            createVideoColorFinderFlight(
                socket,
                { ...args, ...data },
                { sampleDataFlightKey: context?.sampleDataFlightKey }
            )
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["videoColorFinderFlights"],
                })
            )

            store.dispatch(selectSingleLayer({ id: optimisticData.id }))
            store.dispatch(setFlightId(optimisticData.id))
            store.dispatch(setActiveLayerId({ id: optimisticData.id }))
        })
        .addCase(updateAction, (store, { payload: { id, updates, context } }, socket) => {
            updateVideoColorFinderFlight(socket, id, updates, { ...context })

            if (context?.sampleDataFlightKey) updates.demoId = "doesnt-matter"

            store.dispatch(
                updateEntitySocket({ updates, path: ["videoColorFinderFlights", { id }] })
            )
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            const dispatch = store.dispatch
            dispatch(deleteUploadSet({ flightId: id }))
            deleteVideoColorFinderFlight(socket, id, {})
            dispatch(deleteEntitySocket({ path: ["videoColorFinderFlights", { id }] }))
        })
export {
    createAction as createVideoColorFinderFlight,
    updateAction as updateVideoColorFinderFlight,
    deleteAction as deleteVideoColorFinderFlight,
}
